<template>
  <text-box :label="$t('components.simulationDetails.MarketingSales.mediaSalesByChannel', { kpi: customKpiName }) + ` (${unit})`" icon="chart-bar">
    <template v-slot:info v-if="precision">
      <percent-chip :value="precision" :best="100" icon="mdi-bullseye-arrow"/>
    </template>
    <template v-slot:info-dialog>
      <slot name="info-dialog"></slot>
    </template>
    <div v-if="sortedMarketing.length > 17" class="echart-wrap">
      <v-chart :option="options" :init-options="{renderer: 'canvas'}" autoresize :style="`width: 100%; height: ${chartHeight}px;`"/>
    </div>
    <v-chart v-else :option="options" :init-options="{renderer: 'canvas'}" autoresize style="height: 400px; width: 100%;"/>
  </text-box>
</template>

<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/bar'
import 'echarts/lib/component/tooltip'
import { graphic } from 'echarts/core'
import 'zrender/lib/canvas/canvas'
import numbro from 'numbro'

import TextBox from '@/components/TextBox.vue'
import PercentChip from '@/components/PercentChip.vue'

export default {
  data () {
    return {}
  },
  computed: {
    options () {
      return {
        textStyle: {
          fontFamily: '"Roboto","Helvetica",sans-serif',
          lineHeight: 1.2381,
          fontWeight: 400
        },
        grid: {
          top: 20,
          left: '3%',
          right: '20%',
          bottom: '3%',
          containLabel: true
        },
        tooltip: {
          formatter: function () {
            return ''
          }
        },
        toolbox: {
          show: this.export,
          left: 0,
          feature: {
            dataView: {
              readOnly: true,
              title: this.$t('components.simulationDetails.MarketingSales.dataView'),
              lang: [this.$t('components.simulationDetails.MarketingSales.dataView'), this.$t('components.simulationDetails.MarketingSales.close'), this.$t('components.simulationDetails.MarketingSales.refresh')]
            },
            saveAsImage: {
              type: 'png',
              name: this.exportImageName || this.title || `Marketing ${this.customKpiName}`,
              title: this.$t('components.simulationDetails.MarketingSales.saveAsImage')
            }
          },
          showTitle: false,
          tooltip: {
            show: true,
            formatter: function (param) {
              return param.title
            }
          }
        },
        xAxis: {
          type: 'value',
          show: false,
          splitLine: {
            show: false
          }
        },
        yAxis: {
          type: 'category',
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          data: this.sortedMarketing.map(element => element[0])
        },
        series: this.series
      }
    },
    series: function () {
      var series = []
      var totals = this.sortedMarketing
      for (var i = 0; i < totals.length; i++) {
        var dataArray = totals.map((el, elIndex) => i === elIndex ? el[1].adstock : null)
        series.push({
          name: totals[i][0],
          type: 'bar',
          stack: 'stack',
          label: {
            show: true,
            position: 'right',
            formatter: this.formatEchartsValue,
            color: this.colors ? this.colors[totals[i][0]] : 'blue'
          },
          itemStyle: {
            // color: this.colors ? this.colors[totals[i][0]] : 'blue'
            color: new graphic.LinearGradient(2, 0, 0, 0, [
              { offset: 0, color: 'white' },
              { offset: 1, color: this.colors ? this.colors[totals[i][0]] : 'blue' }
            ]),
            borderRadius: [0, 2, 2, 0]
          },
          emphasis: {
            itemStyle: {
              color: new graphic.LinearGradient(3, 0, 0, 0, [
                { offset: 0, color: 'white' },
                { offset: 1, color: this.colors ? this.colors[totals[i][0]] : 'blue' }
              ])
            }
          },
          data: dataArray
        })
      }
      return series
    },
    sortedMarketing: function () {
      if (this.data.marketing) {
        return Object.entries(this.data.marketing).sort((a, b) => a[1].adstock - b[1].adstock)
      } else {
        return Object.entries(this.data.outputs[Object.keys(this.data.outputs)[0]].marketing).sort((a, b) => a[1].adstock - b[1].adstock)
      }
    },
    chartHeight: function () {
      return this.sortedMarketing.length * 25
    },
    totalMarketing: function () {
      return this.sortedMarketing.reduce((acc, cur) => acc + cur[1].adstock, 0)
    }
  },
  methods: {
    formatValue: function (value) {
      return numbro(value).format({
        average: true,
        lowPrecision: false,
        mantissa: 1,
        optionalMantissa: true
      })
    },
    formatEchartsValue: function (obj) {
      console.log(this.totalMarketing)
      if (this.totalMarketing > 0) {
        return `${this.formatValue(obj.value)} (${Math.round(100 * obj.value / this.totalMarketing)}%)`
      } else {
        return '0 (0%)'
      }
    }
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    colors: {
      type: Object,
      required: false
    },
    precision: {
      type: Number,
      required: false
    },
    unit: {
      type: String,
      required: false,
      default: function () {
        return 'USD'
      }
    },
    exportImageName: {
      type: String,
      required: false
    },
    export: {
      type: Boolean,
      required: false,
      default: function () {
        return false
      }
    },
    customKpiName: {
      type: String,
      required: true
    }
  },
  components: {
    'v-chart': ECharts,
    TextBox,
    PercentChip
  }
}
</script>

<style scoped>
  .echart-wrap {
    display: inline-block;
    height: 400px;
    overflow: scroll;
  }
</style>
